/**
 * Konko: eliminar la línea completa de un producto en el carrito lateral
 * con un clic en el ícono de basurero (junto al selector de cantidad).
 *
 * Reutiliza la lógica AJAX ya existente del theme (Impulse):
 *  - theme.cart.changeItem(key, qty) -> POST /cart/change.js
 *    (la misma función que usan los botones "-" y "+")
 *  - evento "cart:build" en document, que theme.CartForm ya escucha
 *    para reconstruir el drawer completo (subtotal, descuentos,
 *    contador, barra de envío gratis, estado de carrito vacío).
 *
 * Un solo listener delegado en document (no en cada botón), porque
 * data-products se reemplaza por completo en cada actualización del
 * carrito: listeners puestos directamente en los botones se perderían.
 */
(function () {
  if (window.__kkCartRemoveBound) return;
  window.__kkCartRemoveBound = true;

  var ERROR_MESSAGE = 'No pudimos eliminar el producto. Inténtalo nuevamente.';

  function setRowBusy(row, busy) {
    if (!row) return;
    row.classList.toggle('is-removing', !!busy);
    row.setAttribute('aria-busy', busy ? 'true' : 'false');
    row.querySelectorAll('button, input').forEach(function (el) {
      el.disabled = !!busy;
    });
  }

  function showError(row) {
    if (!row) return;
    var existing = row.querySelector('.kk-cart-remove-error');
    if (existing) existing.parentNode.removeChild(existing);

    var msg = document.createElement('div');
    msg.className = 'kk-cart-remove-error';
    msg.setAttribute('role', 'alert');
    msg.textContent = ERROR_MESSAGE;
    row.appendChild(msg);

    setTimeout(function () {
      if (msg && msg.parentNode) msg.parentNode.removeChild(msg);
    }, 4000);
  }

  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('[data-cart-remove]');
    if (!trigger) return;

    evt.preventDefault();

    if (trigger.disabled || trigger.getAttribute('aria-busy') === 'true') return;

    var key = trigger.getAttribute('data-cart-remove');
    var row = trigger.closest('.cart__item');

    if (!key || !window.theme || !theme.cart || typeof theme.cart.changeItem !== 'function') {
      return;
    }

    setRowBusy(row, true);
    trigger.setAttribute('aria-busy', 'true');

    theme.cart.changeItem(key, 0)
      .then(function (cart) {
        if (!cart || cart.status) {
          throw new Error('cart_change_failed');
        }
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {
        console.error('[kk-cart-remove] No se pudo eliminar la línea del carrito.');
        setRowBusy(row, false);
        trigger.setAttribute('aria-busy', 'false');
        showError(row);
      });
  });
})();
